module.exports = __webpack_public_path__ + "static/media/cloud.02da8438.png";